import React, { useState } from 'react';
import { Phone, MessageCircle, Clock, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/StickyContactBox.css';

const StickyContactBox = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`sticky-contact-box ${isOpen ? 'open' : 'closed'}`} data-testid="sticky-contact-box">
      <button className="scb-toggle" onClick={() => setIsOpen(!isOpen)} data-testid="sticky-contact-toggle">
        {isOpen ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        {!isOpen && <Phone size={16} className="scb-toggle-icon" />}
      </button>
      {isOpen && (
        <div className="scb-content">
          <div className="scb-header">Registan Tourism</div>
          <div className="scb-item">
            <Clock size={15} className="scb-icon" />
            <div>
              <div className="scb-label">Working Hours</div>
              <div className="scb-value">Mon - Sat: 9:00 - 21:00</div>
            </div>
          </div>
          <div className="scb-item">
            <Phone size={15} className="scb-icon" />
            <div>
              <div className="scb-label">Call Us</div>
              <a href="tel:+971569130707" className="scb-value scb-link">+971 56 913 0707</a>
            </div>
          </div>
          <div className="scb-item">
            <MessageCircle size={15} className="scb-icon scb-whatsapp" />
            <div>
              <div className="scb-label">WhatsApp</div>
              <a href="https://wa.me/971569130707" target="_blank" rel="noopener noreferrer" className="scb-value scb-link scb-wa-link">+971 56 913 0707</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StickyContactBox;
